module.exports = __webpack_public_path__ + "img/glas_empty.fd9f60d9.png";